export default __webpack_public_path__ + "static/media/ic_outline-cases.caa99b94.svg";